import {
    BronzeMedalIcon,
    BronzeShieldIcon,
    SilverMedalIcon,
    SilverShieldIcon,
    GoldShieldIcon,
    GoldMedalIcon,
} from "@icarius-icons/index";

const NAME = "RECOGNITION_PLANS";
export const PRIZE_TYPES = {
    bronzeMedal: {
        icon: BronzeMedalIcon,
        name: "bronzeMedal",
        fieldPrefix: 'MedalBronze',
    },
    silverMedal: {
        icon: SilverMedalIcon,
        name: "silverMedal",
        fieldPrefix: 'MedalSilver',
    },
    goldMedal: {
        icon: GoldMedalIcon,
        name: "goldMedal",
        fieldPrefix: 'MedalGold',
    },
    bronzeShield: {
        icon: BronzeShieldIcon,
        name: "bronzeShield",
        fieldPrefix: 'ShieldBronze',
    },
    silverShield: {
        icon: SilverShieldIcon,
        name: "silverShield",
        fieldPrefix: 'ShieldSilver',
    },
    goldShield: {
        icon: GoldShieldIcon,
        name: "goldShield",
        fieldPrefix: 'ShieldGold',
    }
}

export default NAME;
